/* eslint-disable  */
import React from "react";
import { useHistory } from "react-router-dom";
import { Route, Redirect } from "react-router-dom";


function PrivateLoanAdminRoute({ component: Component, roles, ...rest }) {
  const history = useHistory()
  const token = window.localStorage.getItem("token");
  const user = JSON.parse(window.localStorage.getItem("user"));
  const hasJWT = () => {
    let flag = false
    window.localStorage.getItem("token") ? flag=true : flag=false
    return flag
  }
  // Optional role gate. When `roles` is passed, the logged-in user must hold at
  // least one of them; otherwise they are bounced to the loans home. Routes
  // without a `roles` prop stay open to any authenticated loan admin.
  const hasRole = () => {
    if (!roles || roles.length === 0) return true;
    const userRoles = user?.role || [];
    return roles.some((r) => userRoles.includes(r));
  }
  return (
    <Route
    {...rest}
    render={props =>
      hasJWT()
        ? (hasRole()
            ? <Component {...props}/>
            : <Redirect to={{pathname: '/loans/home'}}/>)
        : <Redirect to={{pathname: '/'}}/>
    }
    />
  );
}

export default PrivateLoanAdminRoute;
